var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53869 2.53846C6.53869 3.38813 5.84989 4.07692 5.00023 4.07692C4.15056 4.07692 3.46176 3.38813 3.46176 2.53846C3.46176 1.68879 4.15056 1 5.00023 1C5.84989 1 6.53869 1.68879 6.53869 2.53846ZM7.52458 2.80769C7.39013 4.08308 6.31124 5.07692 5.00023 5.07692C3.68921 5.07692 2.61032 4.08308 2.47587 2.80769H1.07715C0.801006 2.80769 0.577148 2.58383 0.577148 2.30769C0.577148 2.03155 0.801006 1.80769 1.07715 1.80769H2.56853C2.88235 0.761955 3.8523 0 5.00023 0C6.14815 0 7.1181 0.761955 7.43192 1.80769H14.9233C15.1994 1.80769 15.4233 2.03155 15.4233 2.30769C15.4233 2.58383 15.1994 2.80769 14.9233 2.80769H7.52458ZM15.4233 9.2308C15.4233 8.95466 15.1994 8.7308 14.9233 8.7308H13.4319C13.1181 7.68506 12.1481 6.92311 11.0002 6.92311C9.8523 6.92311 8.88235 7.68506 8.56853 8.7308H1.07715C0.801006 8.7308 0.577148 8.95466 0.577148 9.2308C0.577148 9.50694 0.801006 9.7308 1.07715 9.7308H8.47587C8.61032 11.0062 9.68921 12 11.0002 12C12.3112 12 13.3901 11.0062 13.5246 9.7308H14.9233C15.1994 9.7308 15.4233 9.50694 15.4233 9.2308ZM9.46176 9.46157C9.46176 10.3112 10.1506 11 11.0002 11C11.8499 11 12.5387 10.3112 12.5387 9.46157C12.5387 8.6119 11.8499 7.92311 11.0002 7.92311C10.1506 7.92311 9.46176 8.6119 9.46176 9.46157Z",
    fill: "#2D3958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.85a115a6bb0190608955b3d1c29d7b8a.svg";
export { ForwardRef as ReactComponent };